// extracted by mini-css-extract-plugin
export var close = "MenuModal-module--close--Kpi4I";
export var modal = "MenuModal-module--modal---jU6g";